import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useDashboard from "./useDashboard";

const Dashboard = () => {
  const { drawerMenu } = useDashboard();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default Dashboard;
